import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import Breadcrumb from "components/Common/Breadcrumb2"
import { getJobsExecutions, getJobsOptions } from "services/jobs/calls"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import Select from "react-select"
import { statusMap, statusOptions } from "./constants"
import moment from "moment"
import ModalResults from "./Components/ModalResults"
import ModalErrors from "./Components/ModalErrors"

const MonitoramentoJobs = ({ t }) => {
  document.title = "Monitoramento de Jobs | Sensetek"
  moment.locale("pt-br")

  const [isLoading, setIsLoading] = useState(true)
  const [query, setQuery] = useState({
    jobs: [],
    status: [],
    startStartedAt: null,
    endStartedAt: null,
    startEndedAt: null,
    endEndedAt: null,
  })
  const [jobsList, setJobsList] = useState([])
  const [selectedExecution, setSelectedExecution] = useState(null)
  const [selectedError, setSelectedError] = useState(null)

  const [jobOptions, setJobOptions] = useState([])

  const [showModalResults, setShowModalResults] = useState(false)
  const [showModalErrors, setShowModalErrors] = useState(false)

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "80px",
      },
      align: "center",
      headerAlign: "center",
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "job.jobName",
      text: "Job",
      sort: false,
    },
    {
      dataField: "status",
      text: "Situação",
      sort: false,
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <Badge
          color={statusMap[cellContent]?.color}
          className="badge-warning me-1"
        >
          <b>{statusMap[cellContent]?.label}</b>
        </Badge>
      ),
    },
    {
      dataField: "startedAt",
      text: "Início Execução",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => {
        return cellContent ? (
          <b>{moment(cellContent).format("DD/MM/YYYY HH:mm:ss")}</b>
        ) : (
          "-"
        )
      },
    },
    {
      dataField: "endedAt",
      text: "Fim Execução",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => {
        return cellContent ? (
          <b>{moment(cellContent).format("DD/MM/YYYY HH:mm:ss")}</b>
        ) : (
          "-"
        )
      },
    },
    {
      dataField: "details",
      isDummyField: true,
      text: "Detalhes",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          {row?.result && (
            <React.Fragment>
              <li data-bs-toggle="tooltip" data-bs-placement="top">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    setSelectedExecution(JSON.parse(row?.result))
                    setShowModalResults(true)
                  }}
                >
                  <i
                    className="bx bx-receipt"
                    id={`resultTooltip${row?.id}`}
                  ></i>
                </Button>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`resultTooltip${row?.id}`}
              >
                Resultados
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {row?.errorMessage && (
            <React.Fragment>
              <li data-bs-toggle="tooltip" data-bs-placement="top">
                <Button
                  color="secondary"
                  size="sm"
                  onClick={() => {
                    setSelectedError(row?.errorMessage)
                    setShowModalErrors(true)
                  }}
                >
                  <i
                    className="bx bx-error-circle"
                    id={`errorTooltip${row?.id}`}
                  ></i>
                </Button>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`errorTooltip${row?.id}`}
              >
                Erro
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </ul>
      ),
    },
  ]

  const fetchOptions = async () => {
    try {
      const payload = await getJobsOptions()
      setJobOptions(payload)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }
  const [totalRecords, setTotalRecords] = useState(0)
  // const pageOptions = {
  //   sizePerPage: 20,
  //   totalSize: totalRecords,
  //   custom: true,
  //   showTotal: true,
  //   hideSizePerPage: true,
  //   hidePageListOnlyOnePage: true,
  //   prePageText: "Anterior",
  //   nextPageText: "Próximo",
  //   paginationTotalRenderer: (from, to, size) => {
  //     return (
  //       <div className="d-inline">
  //         <span className="react-bootstrap-table-pagination-total">
  //           Registros Retornados: {size}
  //         </span>
  //       </div>
  //     )
  //   },
  // }
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  const paginationOptions = {
    custom: true,
    page: currentPage,
    sizePerPage: 20,
    totalSize: totalRecords,
    onPageChange: async (page, sizePerPage) => {
      setCurrentPage(page)
      setIsLoading(true)
      try {
        const {
          executions,
          total,
          pagination: { totalPages },
        } = await getJobsExecutions(query, page)
        setJobsList(executions)
        setTotalRecords(total)
        setTotalPages(totalPages)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    },
    showTotal: true,
    hideSizePerPage: false,
    prePageTitle: "Anterior",
    nextPageTitle: "Próxima",
    lastPageTitle: "Última Página",
    firstPageTitle: "Primeira Página",
    paginationTotalRenderer: (from, to, size) => (
      <span>
        Exibindo {from} a {to} de {size} registros. {totalPages} páginas.
      </span>
    ),
  }

  const onQuery = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const {
        executions,
        total,
        pagination: { totalPages },
      } = await getJobsExecutions(query)
      setJobsList(executions)
      setCurrentPage(1)
      setTotalRecords(total)
      setTotalPages(totalPages)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchOptions()
  }, [])

  const onTableChange = (type, newState) => {}

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={t("Monitoramento de Jobs")}
            breadcrumbItems={[{ title: t("Monitoramento"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  Filtro
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontal" onSubmit={onQuery}>
                    <Row>
                      <Col sm={4}>
                        <FormGroup>
                          <Label>Job</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            isMulti
                            placeholder=""
                            closeMenuOnSelect={false}
                            value={query.jobs}
                            isDisabled={isLoading}
                            options={jobOptions}
                            onChange={e => {
                              setQuery({ ...query, jobs: e })
                            }}
                            menuPortalTarget={document.body}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={4}>
                        <FormGroup>
                          <Label>Situação</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            isMulti
                            placeholder=""
                            closeMenuOnSelect={false}
                            value={query.status}
                            isDisabled={isLoading}
                            options={statusOptions}
                            onChange={e => {
                              setQuery({ ...query, status: e })
                            }}
                            menuPortalTarget={document.body}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={4}>
                        <Row>
                          <Col>
                            <FormGroup>
                              <Label>Início Execução (Início)</Label>
                              <DatePicker
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={query.startStartedAt}
                                selectsStart
                                disabled={isLoading}
                                startDate={query.startStartedAt}
                                endDate={query.endStartedAt}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    startStartedAt: e,
                                  })
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <Label>Início Execução (Fim)</Label>
                              <DatePicker
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={query.endStartedAt}
                                selectsEnd
                                disabled={isLoading}
                                startDate={query.startStartedAt}
                                endDate={query.endStartedAt}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    endStartedAt: e,
                                  })
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={4}>
                        <Row>
                          <Col>
                            <FormGroup>
                              <Label>Fim Execução (Início)</Label>
                              <DatePicker
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={query.startEndedAt}
                                selectsStart
                                disabled={isLoading}
                                startDate={query.startEndedAt}
                                endDate={query.endEndedAt}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    startEndedAt: e,
                                  })
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <Label>Fim Execução (Fim)</Label>
                              <DatePicker
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={query.endEndedAt}
                                selectsEnd
                                disabled={isLoading}
                                startDate={query.startEndedAt}
                                endDate={query.endEndedAt}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    endEndedAt: e,
                                  })
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div
                      className="d-flex flex-row-reverse vstack gap-2"
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button color="primary" type="submit">
                        Filtrar
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  Resultado
                </CardHeader>
                <CardBody>
                  {isLoading ? (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  ) : jobsList.length > 0 ? (
                    <PaginationProvider
                      pagination={paginationFactory(paginationOptions)}
                    >
                      {({ paginationTableProps, paginationProps }) => (
                        <ToolkitProvider
                          columns={columns}
                          data={jobsList}
                          keyField="id"
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row>
                                <Col>
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <BootstrapTable
                                    bordered
                                    striped
                                    condensed
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    remote={{
                                      filter: false,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false,
                                    }}
                                    onTableChange={onTableChange}
                                  />
                                </Col>
                              </Row>
                              <PaginationListStandalone {...paginationProps} />
                              <PaginationTotalStandalone {...paginationProps} />
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  ) : (
                    <div style={{ textAlign: "center" }}>
                      <h5>Nenhum dado foi encontrado.</h5>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {selectedExecution && (
        <ModalResults
          details={selectedExecution}
          showModal={showModalResults}
          setShowModal={setShowModalResults}
          onClose={() => {
            setSelectedExecution(null)
          }}
        />
      )}
      {selectedError && (
        <ModalErrors
          details={selectedError}
          showModal={showModalErrors}
          setShowModal={setShowModalErrors}
          onClose={() => {
            setSelectedError(null)
          }}
        />
      )}
    </React.Fragment>
  )
}

MonitoramentoJobs.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(MonitoramentoJobs)
